import {
  Heart, Users, Compass, Plane, Globe, Map, Star,
  Briefcase, Camera, Mountain, Sparkles, Sun,
} from 'lucide-react';

// Registry of icons selectable for service cards.
export const serviceIcons = {
  Heart, Users, Compass, Plane, Globe, Map, Star,
  Briefcase, Camera, Mountain, Sparkles, Sun,
};

export const serviceIconNames = Object.keys(serviceIcons);

export const getServiceIcon = (name) => serviceIcons[name] || Compass;
